import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { NavigationItem } from "../navigation";
import { Location } from "@angular/common";
import {
  IItem,
  IMultiProperties,
} from "src/app/metadata/interfaces/page/Pages";
import { DattaConfig } from "src/app/config/app-config";
import { UtilityService } from "src/app/services/skyaccessconfig/utility.service";
import { SkyaccessApp } from "src/app/services/skyaccessconfig/skyaccess-app.service";

@Component({
  selector: "app-nav-content",
  templateUrl: "./nav-content.component.html",
  styleUrls: ["./nav-content.component.scss"],
})
export class NavContentComponent implements OnInit, AfterViewInit {
  @Output() onNavCollapsedMob = new EventEmitter();
  @Input() IsSkyaccessApp: boolean = false;

  dattaConfig: any;
  navigation: any;
  prevDisabled: string;
  nextDisabled: string;
  contentWidth: number;
  wrapperWidth: any;
  scrollWidth: any;
  windowWidth: number;

  GnSetting: IItem[];
  Properties: IMultiProperties[];
  // ModuleList: IItem[];
  // ModuleList2: IItem[];

  isLoaded: boolean = false;
  onInitCompleted: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild("navbarContent") navbarContent: ElementRef;
  @ViewChild("navbarWrapper") navbarWrapper: ElementRef;

  constructor(
    public nav: NavigationItem,
    private zone: NgZone,
    private location: Location,
    private utilityService: UtilityService,
    private skyAcceAp: SkyaccessApp
  ) {
    this.dattaConfig = DattaConfig.config;
    this.windowWidth = window.innerWidth;

    this.navigation = this.nav.get();
    this.prevDisabled = "disabled";
    this.nextDisabled = "";
    this.scrollWidth = 0;
    this.contentWidth = 0;

    console.log(this.navigation, "navigation");
  }

  ngOnInit() {
    this.isLoaded = true;
    if (innerWidth < 992) {
      this.dattaConfig["layout"] = "vertical";
      setTimeout(() => {
        document
          .querySelector(".pcoded-navbar")
          .classList.add("menupos-static");
        (
          document.querySelector("#nav-ps-datta") as HTMLElement
        ).style.maxHeight = "100%";
      }, 500);
    }
    return;
  }

  ngAfterViewInit() {
    if (this.dattaConfig["layout"] === "horizontal") {
      this.contentWidth = this.navbarContent.nativeElement.clientWidth;
      this.wrapperWidth = this.navbarWrapper.nativeElement.clientWidth;
    }
    return;
    this.onInitCompleted.subscribe((value) => {
      try {
        if (this.dattaConfig["layout"] === "horizontal") {
          this.contentWidth = this.navbarContent.nativeElement.clientWidth;
          this.wrapperWidth = this.navbarWrapper.nativeElement.clientWidth;
        }
      } catch (ex) {
        this.skyAcceAp.LogEx("nav-content ngAfterViewInit :" + ex.message);
      }
    });
  }

  scrollPlus() {
    this.scrollWidth = this.scrollWidth + (this.wrapperWidth - 80);
    if (this.scrollWidth > this.contentWidth - this.wrapperWidth) {
      this.scrollWidth = this.contentWidth - this.wrapperWidth + 80;
      this.nextDisabled = "disabled";
    }
    this.prevDisabled = "";
    (
      document.querySelector("#side-nav-horizontal") as HTMLElement
    ).style.marginLeft = "-" + this.scrollWidth + "px";
  }

  scrollMinus() {
    this.scrollWidth = this.scrollWidth - this.wrapperWidth;
    if (this.scrollWidth < 0) {
      this.scrollWidth = 0;
      this.prevDisabled = "disabled";
    }
    this.nextDisabled = "";
    (
      document.querySelector("#side-nav-horizontal") as HTMLElement
    ).style.marginLeft = "-" + this.scrollWidth + "px";
  }

  fireLeave() {
    const sections = document.querySelectorAll(".pcoded-hasmenu");
    for (let i = 0; i < sections.length; i++) {
      sections[i].classList.remove("active");
      sections[i].classList.remove("pcoded-trigger");
    }

    let current_url = this.location.path();
    if (this.location["_baseHref"]) {
      current_url = this.location["_baseHref"] + this.location.path();
    }
    const link = "a.nav-link[ href='" + current_url + "' ]";
    const ele = document.querySelector(link);
    if (ele !== null && ele !== undefined) {
      const parent = ele.parentElement;
      const up_parent = parent.parentElement.parentElement;
      const last_parent = up_parent.parentElement;
      if (parent.classList.contains("pcoded-hasmenu")) {
        parent.classList.add("active");
      } else if (up_parent.classList.contains("pcoded-hasmenu")) {
        up_parent.classList.add("active");
      } else if (last_parent.classList.contains("pcoded-hasmenu")) {
        last_parent.classList.add("active");
      }
    }
  }

  navMob() {
    if (
      this.windowWidth < 992 &&
      document
        .querySelector("app-navigation.pcoded-navbar")
        .classList.contains("mob-open")
    ) {
      this.onNavCollapsedMob.emit();
    }
  }

  fireOutClick() {
    let current_url = this.location.path();
    if (this.location["_baseHref"]) {
      current_url = this.location["_baseHref"] + this.location.path();
    }
    const link = "a.nav-link[ href='" + current_url + "' ]";
    const ele = document.querySelector(link);
    if (ele !== null && ele !== undefined) {
      const parent = ele.parentElement;
      // (link, ele, parent, current_url);
      const up_parent = parent.parentElement.parentElement;
      const last_parent = up_parent.parentElement;
      if (parent.classList.contains("pcoded-hasmenu")) {
        if (this.dattaConfig["layout"] === "vertical") {
          parent.classList.add("pcoded-trigger");
        }
        parent.classList.add("active");
      } else if (up_parent.classList.contains("pcoded-hasmenu")) {
        if (this.dattaConfig["layout"] === "vertical") {
          up_parent.classList.add("pcoded-trigger");
        }
        up_parent.classList.add("active");
      } else if (last_parent.classList.contains("pcoded-hasmenu")) {
        const third_parent =
          last_parent.parentElement.parentElement.parentElement;
        if (third_parent.classList.contains("pcoded-hasmenu")) {
          third_parent.classList.add("pcoded-trigger");
        }
        if (this.dattaConfig["layout"] === "vertical") {
          last_parent.classList.add("pcoded-trigger");
        }
        last_parent.classList.add("active");
      }
    }
  }
}
